<div class="image-collection">
	<div class="image" *ngIf="images && images.length > 0 && images[0]">
		<img [src]="images[0]" alt="" />
	</div>
	<div class="image" *ngIf="images && images.length > 1 && images[1]">
		<img [src]="images[1]" alt="" />
	</div>
</div>

<div *ngIf="title" class="title" [innerHtml]="title"></div>
